import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Smartphone, Tv, Wifi, Zap, Shield, Clock, Users, Phone, Mail, MapPin, ChevronRight, Signal, IndianRupee, Headphones, ArrowRight, Star, Menu, X } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const OPERATORS = [
  { label: 'JIO', value: 'jio' },
  { label: 'Airtel', value: 'airtel' },
  { label: 'VI', value: 'vi' },
  { label: 'BSNL', value: 'bsnl_topup' },
];

const Landing = () => {
  const [mobileNav, setMobileNav] = useState(false);
  const [site, setSite] = useState({
    site_company_name: 'TRIPATHY TELECOM',
    site_phone: '+91 9999999999',
    site_email: 'info@tripathytelecom.shop',
    site_address: 'West Bengal, India',
    site_tagline: 'Bharat-er sobcheye bhorsajogyo recharge platform',
    site_about: '',
  });

  useEffect(() => {
    axios.get(`${API_URL}/api/settings/site`)
      .then(res => setSite(prev => ({ ...prev, ...res.data })))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white font-[Outfit,sans-serif]" data-testid="landing-page">
      {/* ─── NAVBAR ─── */}
      <nav className="fixed top-0 w-full z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100" data-testid="navbar">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: '#1e1b4b' }}>
                <Signal className="w-5 h-5 text-white" />
              </div>
              <span className="text-lg font-bold tracking-tight" style={{ color: '#4680ff' }}>
                {site.site_company_name}
              </span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <a href="#services" className="text-sm font-medium text-slate-600 hover:text-[#1e1b4b] transition-colors">Services</a>
              <a href="#plans" className="text-sm font-medium text-slate-600 hover:text-[#1e1b4b] transition-colors">Plans</a>
              <a href="#about" className="text-sm font-medium text-slate-600 hover:text-[#1e1b4b] transition-colors">About</a>
              <a href="#contact" className="text-sm font-medium text-slate-600 hover:text-[#1e1b4b] transition-colors">Contact</a>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <Link to="/login" data-testid="nav-login-btn">
                <Button variant="outline" className="rounded-full px-6 border-[#1e1b4b] text-[#1e1b4b] hover:bg-[#1e1b4b] hover:text-white font-semibold text-sm">
                  Login
                </Button>
              </Link>
              <Link to="/register" data-testid="nav-register-btn">
                <Button className="rounded-full px-6 font-semibold text-sm text-white" style={{ background: '#f97316' }}>
                  Get Started
                </Button>
              </Link>
            </div>

            <button className="md:hidden p-2" onClick={() => setMobileNav(!mobileNav)} data-testid="mobile-menu-toggle">
              {mobileNav ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile nav */}
        {mobileNav && (
          <div className="md:hidden border-t bg-white px-4 py-4 space-y-3">
            <a href="#services" className="block text-sm font-medium text-slate-700" onClick={() => setMobileNav(false)}>Services</a>
            <a href="#plans" className="block text-sm font-medium text-slate-700" onClick={() => setMobileNav(false)}>Plans</a>
            <a href="#about" className="block text-sm font-medium text-slate-700" onClick={() => setMobileNav(false)}>About</a>
            <a href="#contact" className="block text-sm font-medium text-slate-700" onClick={() => setMobileNav(false)}>Contact</a>
            <div className="flex gap-3 pt-2">
              <Link to="/login" className="flex-1"><Button variant="outline" className="w-full rounded-full border-[#1e1b4b] text-[#1e1b4b]">Login</Button></Link>
              <Link to="/register" className="flex-1"><Button className="w-full rounded-full text-white" style={{ background: '#f97316' }}>Get Started</Button></Link>
            </div>
          </div>
        )}
      </nav>

      {/* ─── HERO ─── */}
      <section className="relative pt-16 overflow-hidden" style={{ background: '#1e1b4b' }} data-testid="hero-section">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-96 h-96 rounded-full" style={{ background: '#f97316', filter: 'blur(120px)' }} />
          <div className="absolute bottom-10 left-10 w-72 h-72 rounded-full" style={{ background: '#312e81', filter: 'blur(100px)' }} />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-28">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left content */}
            <div className="text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-sm mb-6">
                <Zap className="w-4 h-4 text-[#f97316]" />
                <span className="text-sm text-white/90 font-medium">#1 Trusted Recharge Platform</span>
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-4">
                Instant Mobile
                <span className="block" style={{ color: '#f97316' }}>Recharge & Pay</span>
              </h1>

              <p className="text-lg text-white/70 mb-2 font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
                {site.site_tagline}
              </p>
              <p className="text-base text-white/50 mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>
                Complete solution for distributors and retailers. Fast, secure, and reliable.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-12">
                <Link to="/register">
                  <Button className="rounded-full px-8 py-6 text-base font-bold text-white shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 transition-all" style={{ background: '#f97316' }} data-testid="hero-cta-btn">
                    Start Earning Now
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
                <Link to="/login">
                  <Button variant="outline" className="rounded-full px-8 py-6 text-base font-bold border-white/30 text-white hover:bg-white/10 bg-transparent">
                    Dealer Login
                  </Button>
                </Link>
              </div>

              {/* Stats inline */}
              <div className="grid grid-cols-3 gap-6">
                <div>
                  <div className="text-3xl font-bold text-white">10K+</div>
                  <div className="text-sm text-white/50">Active Retailers</div>
                </div>
                <div>
                  <div className="text-3xl font-bold" style={{ color: '#f97316' }}>50L+</div>
                  <div className="text-sm text-white/50">Daily Transactions</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-white">99.9%</div>
                  <div className="text-sm text-white/50">Success Rate</div>
                </div>
              </div>
            </div>

            {/* Right - Recharge card */}
            <div className="relative">
              <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-2xl shadow-black/20" data-testid="hero-recharge-form">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: '#1e1b4b' }}>
                    <Smartphone className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900 text-lg">Quick Recharge</h3>
                    <p className="text-xs text-slate-500">Instant prepaid & DTH recharge</p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-semibold text-slate-700 mb-1.5 block">Mobile Number</label>
                    <div className="flex items-center border-2 border-slate-200 rounded-xl px-4 py-3 focus-within:border-[#1e1b4b] transition-colors">
                      <Phone className="w-4 h-4 text-slate-400 mr-3" />
                      <input type="tel" placeholder="Enter 10-digit number" className="flex-1 outline-none text-sm text-slate-800 placeholder:text-slate-400" data-testid="hero-mobile-input" />
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-semibold text-slate-700 mb-1.5 block">Operator</label>
                    <select className="w-full border-2 border-slate-200 rounded-xl px-4 py-3 text-sm text-slate-700 outline-none focus:border-[#1e1b4b] transition-colors bg-white" data-testid="hero-operator-select">
                      <option value="">Select Operator</option>
                      {OPERATORS.map(op => (
                        <option key={op.value} value={op.value}>{op.label}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="text-sm font-semibold text-slate-700 mb-1.5 block">Amount</label>
                    <div className="flex items-center border-2 border-slate-200 rounded-xl px-4 py-3 focus-within:border-[#1e1b4b] transition-colors">
                      <IndianRupee className="w-4 h-4 text-slate-400 mr-3" />
                      <input type="number" placeholder="Enter amount" className="flex-1 outline-none text-sm text-slate-800 placeholder:text-slate-400" data-testid="hero-amount-input" />
                    </div>
                  </div>

                  <Link to="/login" className="block">
                    <Button className="w-full rounded-xl py-6 text-base font-bold text-white shadow-lg transition-all hover:shadow-xl" style={{ background: '#f97316' }} data-testid="hero-recharge-btn">
                      RECHARGE NOW
                    </Button>
                  </Link>

                  <p className="text-center text-xs text-slate-400">Login required to complete recharge</p>
                </div>
              </div>

              {/* Floating badges */}
              <div className="absolute -top-4 -right-4 bg-green-500 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg hidden lg:block">
                LIVE
              </div>
            </div>
          </div>
        </div>

        {/* Wave divider */}
        <div className="relative -mb-1">
          <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
            <path d="M0 80L60 72C120 64 240 48 360 42.7C480 37 600 43 720 48C840 53 960 59 1080 56C1200 53 1320 43 1380 37.3L1440 32V80H1380C1320 80 1200 80 1080 80C960 80 840 80 720 80C600 80 480 80 360 80C240 80 120 80 60 80H0Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* ─── SERVICES ─── */}
      <section id="services" className="py-20 bg-white" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-left mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-50 mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#f97316]" />
              <span className="text-xs font-semibold text-[#f97316] uppercase tracking-wider">Our Services</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-3">
              Amader Services
            </h2>
            <p className="text-base text-slate-500 max-w-xl">
              One platform, every recharge. Prepaid, DTH, data pack — sob kichhu ek jaygay.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: Smartphone, title: 'Mobile Recharge', desc: 'All operators - JIO, Airtel, VI, BSNL', color: '#4680ff' },
              { icon: Tv, title: 'DTH Recharge', desc: 'Tata Sky, Dish TV, Airtel DTH, D2H', color: '#f97316' },
              { icon: Wifi, title: 'Data Packs', desc: 'Best data plans at lowest prices', color: '#4680ff' },
              { icon: Zap, title: 'Bill Payment', desc: 'Electricity, gas & utility bills', color: '#f97316' },
            ].map((svc, i) => (
              <div
                key={i}
                className="group relative bg-white border-2 border-slate-100 rounded-2xl p-6 hover:border-transparent hover:shadow-xl transition-all duration-300 cursor-pointer"
                data-testid={`service-card-${i}`}
              >
                <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5 transition-transform group-hover:scale-110" style={{ background: `${svc.color}12` }}>
                  <svc.icon className="w-7 h-7" style={{ color: svc.color }} />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{svc.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{svc.desc}</p>
                <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-[#f97316] absolute top-6 right-6 transition-colors" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── PLANS ─── */}
      <section id="plans" className="py-20 bg-slate-50" data-testid="plans-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-left mb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-[#1e1b4b]" />
              <span className="text-xs font-semibold text-[#1e1b4b] uppercase tracking-wider">Popular Plans</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-3">
              Best Recharge Plans
            </h2>
            <p className="text-base text-slate-500 max-w-xl">
              Sobcheye bhalo plan, sobcheye kom daam. Choose your operator.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              { op: 'JIO', amount: 299, validity: '28 days', data: '2GB/day', calls: 'Unlimited', popular: true },
              { op: 'Airtel', amount: 265, validity: '28 days', data: '1.5GB/day', calls: 'Unlimited', popular: false },
              { op: 'VI', amount: 269, validity: '28 days', data: '1.5GB/day', calls: 'Unlimited', popular: false },
              { op: 'JIO', amount: 666, validity: '84 days', data: '1.5GB/day', calls: 'Unlimited', popular: true },
              { op: 'Airtel', amount: 455, validity: '84 days', data: '1GB/day', calls: 'Unlimited', popular: false },
              { op: 'BSNL', amount: 107, validity: '30 days', data: '1GB/day', calls: 'Unlimited', popular: false },
            ].map((plan, i) => (
              <div
                key={i}
                className={`relative rounded-2xl p-5 border-2 transition-all hover:shadow-lg ${plan.popular ? 'border-[#f97316] bg-white' : 'border-slate-100 bg-white'}`}
                data-testid={`plan-card-${i}`}
              >
                {plan.popular && (
                  <div className="absolute -top-3 right-4 bg-[#f97316] text-white text-[10px] font-bold px-3 py-1 rounded-full flex items-center gap-1">
                    <Star className="w-3 h-3" /> POPULAR
                  </div>
                )}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: '#1e1b4b' }}>
                      <Signal className="w-4 h-4 text-white" />
                    </div>
                    <span className="font-bold text-sm text-slate-700">{plan.op}</span>
                  </div>
                  <div className="text-right">
                    <span className="text-2xl font-bold text-slate-900">
                      <span className="text-base">&#8377;</span>{plan.amount}
                    </span>
                  </div>
                </div>
                <div className="space-y-2 text-sm text-slate-600">
                  <div className="flex justify-between"><span>Validity</span><span className="font-semibold text-slate-800">{plan.validity}</span></div>
                  <div className="flex justify-between"><span>Data</span><span className="font-semibold text-slate-800">{plan.data}</span></div>
                  <div className="flex justify-between"><span>Calls</span><span className="font-semibold text-slate-800">{plan.calls}</span></div>
                </div>
                <Link to="/login" className="block mt-4">
                  <Button variant="outline" className="w-full rounded-xl border-[#1e1b4b] text-[#1e1b4b] hover:bg-[#1e1b4b] hover:text-white font-semibold text-sm" data-testid={`plan-recharge-btn-${i}`}>
                    Recharge Now
                  </Button>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── WHY CHOOSE US (Stats) ─── */}
      <section className="py-20" style={{ background: '#1e1b4b' }} data-testid="stats-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-4">
                Keno Tripathy Telecom?
              </h2>
              <p className="text-white/60 text-base mb-8 max-w-lg">
                Amra provide kori fastest recharge service, best commission rate, ebong 24/7 support. Apnar business-er jonno shob theke bhalo partner.
              </p>

              <div className="space-y-5">
                {[
                  { icon: Zap, title: 'Lightning Fast', desc: 'Recharge within 3 seconds' },
                  { icon: Shield, title: 'Bank Grade Security', desc: 'Encrypted and PCI-DSS compliant' },
                  { icon: IndianRupee, title: 'Best Commission', desc: 'Highest margin in the industry' },
                  { icon: Headphones, title: '24/7 Support', desc: 'Dedicated help, always available' },
                ].map((f, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-white/10 flex-shrink-0">
                      <f.icon className="w-5 h-5" style={{ color: '#f97316' }} />
                    </div>
                    <div>
                      <h4 className="text-white font-bold text-sm">{f.title}</h4>
                      <p className="text-white/50 text-sm">{f.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-2 gap-5">
              {[
                { num: '10,000+', label: 'Active Retailers', color: '#f97316' },
                { num: '50L+', label: 'Daily Transactions', color: '#ffffff' },
                { num: '99.9%', label: 'Success Rate', color: '#f97316' },
                { num: '24/7', label: 'Support Available', color: '#ffffff' },
              ].map((s, i) => (
                <div key={i} className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 text-center border border-white/10" data-testid={`stat-card-${i}`}>
                  <div className="text-3xl sm:text-4xl font-bold mb-1" style={{ color: s.color }}>{s.num}</div>
                  <div className="text-sm text-white/50">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ─── ABOUT ─── */}
      <section id="about" className="py-20 bg-white" data-testid="about-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-50 mb-4">
                <span className="w-1.5 h-1.5 rounded-full bg-[#f97316]" />
                <span className="text-xs font-semibold text-[#f97316] uppercase tracking-wider">About Us</span>
              </div>
              <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-4">
                Amader Kotha
              </h2>
              <p className="text-base text-slate-500 mb-6 leading-relaxed">
                Tripathy Telecom holo ekta trusted mobile recharge and bill payment platform. 
                Amra distributors ebong retailers der jonno ekta complete solution provide kori — 
                jate tara tader recharge business easily manage korte paren ebong commission earn korte paren.
              </p>
              <p className="text-base text-slate-500 mb-8 leading-relaxed">
                Amader vision holo shob retailer jeno fast, secure, ebong profitable recharge service 
                paye — choto shop theke boro business, shobai amader sathe grow korte parben.
              </p>

              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/register">
                  <Button className="rounded-full px-8 py-5 font-bold text-white" style={{ background: '#1e1b4b' }} data-testid="about-cta-btn">
                    Become a Partner
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100">
                  <Users className="w-8 h-8 mb-3" style={{ color: '#4680ff' }} />
                  <h4 className="font-bold text-slate-900 mb-1">Multi-Level Network</h4>
                  <p className="text-sm text-slate-500">Admin, Distributor, Retailer hierarchy</p>
                </div>
                <div className="bg-[#1e1b4b] rounded-2xl p-6">
                  <IndianRupee className="w-8 h-8 mb-3 text-[#f97316]" />
                  <h4 className="font-bold text-white mb-1">Wallet System</h4>
                  <p className="text-sm text-white/60">Instant credit & debit tracking</p>
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="bg-[#f97316] rounded-2xl p-6">
                  <Zap className="w-8 h-8 mb-3 text-white" />
                  <h4 className="font-bold text-white mb-1">Real-time API</h4>
                  <p className="text-sm text-white/80">Instant recharge processing</p>
                </div>
                <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100">
                  <Clock className="w-8 h-8 mb-3" style={{ color: '#f97316' }} />
                  <h4 className="font-bold text-slate-900 mb-1">Instant Reports</h4>
                  <p className="text-sm text-slate-500">Real-time analytics & reports</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── CTA BANNER ─── */}
      <section className="py-16" style={{ background: 'linear-gradient(135deg, #1e1b4b 0%, #283593 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3 tracking-tight">
            Aj-i Shuru Korun!
          </h2>
          <p className="text-white/60 text-base mb-8 max-w-lg mx-auto">
            Register korun, wallet e balance add korun, ebong recharge shuru korun. Kono hassle nei.
          </p>
          <Link to="/register">
            <Button className="rounded-full px-10 py-6 text-base font-bold text-white shadow-lg shadow-orange-500/30" style={{ background: '#f97316' }} data-testid="cta-register-btn">
              Free Registration
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>

      {/* ─── FOOTER ─── */}
      <footer id="contact" className="pt-16 pb-8" style={{ background: '#0d1242' }} data-testid="footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: '#f97316' }}>
                  <Signal className="w-5 h-5 text-white" />
                </div>
                <span className="text-lg font-bold text-white tracking-tight">{site.site_company_name}</span>
              </div>
              <p className="text-sm text-white/50 leading-relaxed">
                {site.site_tagline}. Fast, secure, reliable.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Quick Links</h4>
              <ul className="space-y-2.5">
                {['Mobile Recharge', 'DTH Recharge', 'Bill Payment', 'Plans & Offers'].map((l, i) => (
                  <li key={i}><a href="#services" className="text-sm text-white/50 hover:text-[#f97316] transition-colors">{l}</a></li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Company</h4>
              <ul className="space-y-2.5">
                {['About Us', 'Terms & Conditions', 'Privacy Policy', 'Refund Policy'].map((l, i) => (
                  <li key={i}><a href="#about" className="text-sm text-white/50 hover:text-[#f97316] transition-colors">{l}</a></li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Contact</h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-3">
                  <Phone className="w-4 h-4 text-[#f97316] flex-shrink-0" />
                  <span className="text-sm text-white/50">{site.site_phone}</span>
                </li>
                <li className="flex items-center gap-3">
                  <Mail className="w-4 h-4 text-[#f97316] flex-shrink-0" />
                  <span className="text-sm text-white/50">{site.site_email}</span>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin className="w-4 h-4 text-[#f97316] flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-white/50">{site.site_address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-6">
            <p className="text-center text-xs text-white/30">
              &copy; 2026 {site.site_company_name}. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Landing;
